import { queryOptions } from '@tanstack/react-query';
import { QuickAddressesResponse } from '../../../global-types';
import { getNonPaginatedQuickAddresses } from '../../../services/address';

export const getAddressBookAddresses = (options?: {
  onSuccess?: (data: NonNullable<QuickAddressesResponse['data']>) => void;
  onError?: (error: any) => void;
}) =>
  queryOptions({
    queryKey: ['addresses'],
    queryFn: () =>
      getNonPaginatedQuickAddresses({})
        .then((res) => {
          if (!res.data) {
            throw new Error('No data returned from API');
          }

          options?.onSuccess?.(res.data);

          return res.data;
        })
        .catch((err) => {
          options?.onError?.(err);

          throw err;
        }),
  });
